function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M121.014 22.4231L99.5826 0.986587C98.2675 -0.328858 96.1352 -0.328859 94.8201 0.986586L73.3891 22.4231C72.0739 23.7385 72.0739 25.8713 73.3891 27.1868C74.7042 28.5022 76.8364 28.5022 78.1515 27.1868L93.8338 11.5005L93.8338 32.8589C93.8338 46.337 82.9104 57.2632 69.4358 57.2632L61 57.2632L61 64L69.4358 64C86.6301 64 100.569 50.0577 100.569 32.8589L100.569 11.5005L116.251 27.1868C117.566 28.5022 119.699 28.5022 121.014 27.1868C122.329 25.8713 122.329 23.7385 121.014 22.4231Z",
  fill: "#A50034"
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M0.986336 41.5769L22.4174 63.0134C23.7325 64.3289 25.8648 64.3289 27.1799 63.0134L48.6109 41.5769C49.9261 40.2615 49.9261 38.1287 48.6109 36.8132C47.2958 35.4978 45.1636 35.4978 43.8485 36.8132L28.1662 52.4995L28.1662 31.1411C28.1662 17.663 39.0896 6.73684 52.5642 6.73684L61 6.73684L61 2.66639e-06L52.5642 2.29766e-06C35.3699 1.54607e-06 21.4311 13.9423 21.4311 31.1411L21.4311 52.4995L5.7488 36.8132C4.43368 35.4978 2.30145 35.4978 0.986337 36.8132C-0.328781 38.1287 -0.328781 40.2615 0.986336 41.5769Z",
  fill: "#A50034"
});

function SvgFlip(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 122,
    height: 64,
    viewBox: "0 0 122 64",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlip);
export default __webpack_public_path__ + "static/media/flip.9df5bd26.svg";
export { ForwardRef as ReactComponent };